import React, { Component } from "react";
import TopBar from "../components/TopBar";

class Home extends Component {
  render() {
    return (
      <>
        <TopBar />
        <div className="xp-page">
          <div className="xp-card">
            <div className="xp-badge xp-badge-neutral">
              <i className="fas fa-map-signs"></i>
            </div>
            <h2>Página no encontrada</h2>
            <p className="xp-sub">
              El enlace que seguiste no existe o ya no está disponible. Revisa
              el correo de tu reserva para acceder al pago.
            </p>
            <div className="xp-trust">
              <i className="fas fa-lock"></i> Pago seguro · Transacción
              protegida
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default Home;
